import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './i18n';

import App from './components/App';

ReactDOM.render(
    <App />,
    document.querySelector('#root')
);



